const PhoneCallIcon = () => {
    return (
        <svg
            width="8"
            height="10"
            viewBox="0 0 8 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.8031 9.79558C5.36284 10.5613 2.89683 9.10914 1.29384 6.55291C-0.308437 3.99613 -0.440804 1.30305 0.998871 0.537185L2.844 3.48079L2.42949 3.70162C2.08957 3.88214 1.97238 4.28566 2.16852 4.59816L3.56925 6.83236C3.76539 7.1454 4.20296 7.25332 4.54288 7.0728L4.95739 6.85197L6.8031 9.79558ZM7.05195 9.66306L7.65343 9.3433C7.98417 9.16787 8.09829 8.77486 7.90769 8.47027L6.75628 6.63396C6.56567 6.32937 6.13845 6.22426 5.8083 6.3998L5.20683 6.71956L7.05195 9.66306ZM1.24831 0.404774L1.84919 0.0850145C2.18005 -0.0905226 2.60668 0.014583 2.79788 0.319172L3.94858 2.15538C4.13978 2.46008 4.02506 2.85298 3.69491 3.02851L3.09344 3.34827L1.24831 0.404774Z"
                fill="white"
            />
        </svg>
    );
};

export default PhoneCallIcon;
